import script from "./Siding01QuestionnarieSection.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding01QuestionnarieSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__